@if (image) {
  <picture>
    <source type="image/webp" [srcset]="getWebpSrcset()" [attr.sizes]="getSizes()">
    <img [src]="getFallbackSrc()"
      [attr.alt]="getAlt()"
      [attr.title]="getTitle()"
      [class]="getImgClasses()"
      [style.object-fit]="'cover'"
      [style.object-position]="'center'"
      [attr.loading]="loading"
      [attr.width]="width || null"
      [attr.height]="height || null"
      [attr.fetchpriority]="fetchpriority || null"
      [attr.sizes]="getSizes()"
    />
  </picture>
}
